(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/unavailable-ticket.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/unavailable-ticket.js');
"use strict";

const Image = svs.content.image_v2.Image;
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect;
const UnavailableTicket = _ref => {
  let history = _ref.history,
    _ref$voucher = _ref.voucher,
    voucher = _ref$voucher === void 0 ? {} : _ref$voucher;
  const getImageForVoucher = useCallback(voucher => {
    var _svs$ticket_gifts$gam, _game$skins;
    const game = (_svs$ticket_gifts$gam = svs.ticket_gifts.games) === null || _svs$ticket_gifts$gam === void 0 ? void 0 : _svs$ticket_gifts$gam.find(game => game.voucherId === voucher.voucherConfigId);
    const skinId = game !== null && game !== void 0 && game.normalizeSkinId ? game.normalizeSkinId(voucher.ticketPosition) : 1;
    return {
      img: game === null || game === void 0 || (_game$skins = game.skins[skinId - 1]) === null || _game$skins === void 0 ? void 0 : _game$skins.image,
      type: game === null || game === void 0 ? void 0 : game.type
    };
  }, []);
  const _getImageForVoucher = getImageForVoucher(voucher),
    _getImageForVoucher$i = _getImageForVoucher.img,
    img = _getImageForVoucher$i === void 0 ? null : _getImageForVoucher$i,
    type = _getImageForVoucher.type;
  useEffect(() => {
    svs.ticket_gifts.redeem.components.util.showNotAvailableDialog(type, () => history && history.push("../../".concat(voucher.voucherId, "/streckkod")));
    return () => svs.ticket_gifts.redeem.components.util.hideNotAvailableDialog();
  }, [history, type, voucher.voucherId]);
  return React.createElement("div", {
    className: "unavailable-tg-container padding-top-2",
    "data-testid": "unavailable-ticket"
  }, img ? React.createElement("div", {
    className: "unavailable-img-wrapper"
  }, React.createElement(Image, {
    cssSelectors: "unavailable-ticket-img",
    image: img
  })) : React.createElement("div", {
    className: "u-flex u-flex-justify-content-center"
  }, React.createElement("img", {
    className: "unavailable-ticket-img-default padding-2",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presentpaket-mockup.png")
  })));
};
setGlobal('svs.ticket_gifts.redeem.components.unavailableTicket.UnavailableTicket', UnavailableTicket);

 })(window);